var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.886 4.463a2.455 2.455 0 01-2.443 2.462A2.45 2.45 0 012 4.463 2.455 2.455 0 014.443 2a2.455 2.455 0 012.443 2.463zm-.357 4.204H2.4V22h4.129V8.667zm6.6 0H9.17V22h3.958v-6.995c0-1.877.864-2.99 2.514-2.99 1.521 0 2.25 1.07 2.25 2.99V22H22v-8.444c0-3.569-2.021-5.296-4.857-5.296-2.829 0-4.022 2.205-4.022 2.205V8.667h.008z"}));
}

SocialLinkedin.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
